// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__kY3ix","slide-left-and-fade":"styles_slide-left-and-fade__bZzV6","arrow":"styles_arrow__v0LiR"};